"use client";

export default function Footer() {
  return (
    <footer className="bg-white border-t">
      <div className=" max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <div className="flex items-center justify-center gap-4 w-full   sm:w-auto md:justify-between">
            <a href="https://risegate.vn/" target="_blank">
              <img
                className="cursor-pointer h-6 md:h-8"
                src="/logo_risegate.svg"
                alt="risegate"
              />
            </a>
          </div>
          <div className="typography-h6 flex-1 text-right">
            <span className="text-[#9EA3AE] font-medium text-sm md:text-base">
              Powered by{" "}
            </span>
            <a href="https://risegate.vn/" target="_blank">
              <b className="text-[#4D5461] text-sm md:text-base">
                MetaDAP Enterprise Blockchain
              </b>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
